import moment from 'moment';
import { FacebookPixel } from 'react-meta-pixel';

class FbPixelService {
	constructor() {
		this.pixel = null;
		this.pixelId = null;
	}

	initIfIdIsSet(pixelId) {
		try {
			if (pixelId && this.pixelId !== pixelId) {
				this.pixelId = pixelId;
				this.pixel = new FacebookPixel({
					pixelID: pixelId,
					autoConfig: true,
					debug: false,
					pageViewOnInit: true,
				});
				this.pixel.init({});
			}
		} catch (error) {
			console.warn('Error occured in initIfIdIsSet: ', error);
		}
	}

	trackPurchaseOrCheckout(shoppingcart, fbEventType) {
		try {
			if (!shoppingcart || !shoppingcart.events || !shoppingcart.events.length) {
				console.warn('Tried to track empty shoppingcart.');
				return;
			}

			const scEvent = shoppingcart.events[0];
			const eventTitleDate = `${scEvent.event} - ${moment(scEvent.eventBegin).format('DD.MM.YYYY HH:mm')}`;

			const value = shoppingcart.events
				.flatMap(event => event.displayTickets)
				.map(ticket => ticket?.subTotal?.money?.value || 0)
				.reduce((acc, curr) => acc + curr, 0);

			const data = {
				content_name: eventTitleDate,
				currency: 'EUR',
				value,
			};

			if (this.pixel) {
				this.pixel.trackEvent(fbEventType, data);
			}
		} catch (error) {
			console.warn('Error occured in trackPurchaseOrCheckout: ', error);
		}
	}
}

const fbPixelService = new FbPixelService();
export default fbPixelService;
